import React from 'react';
import clsx from 'clsx';

export const Skeleton: React.FC<{ className?: string }> = ({ className }) => (
  <div className={clsx('shimmer rounded-md bg-border/60', className)} aria-hidden />
);

/** Table placeholder with the real column shape, so the page doesn't reflow on load. */
export const TableSkeleton: React.FC<{ rows?: number; cols: number }> = ({ rows = 8, cols }) => (
  <tbody>
    {Array.from({ length: rows }).map((_, r) => (
      <tr key={r} className="border-t border-border">
        {Array.from({ length: cols }).map((__, c) => (
          <td key={c} className="px-4 py-3">
            <Skeleton className={clsx('h-3.5', c === 0 ? 'w-40' : c === cols - 1 ? 'w-16' : 'w-24')} />
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);
